import {  apiStartState } from '../../../../utils/reduxOperations';

export function handleLoginProcessStarted(state, payload) {
    return {
        ...state,
        loginApi:apiStartState(state.loginApi)
    };
}